import { PersonId } from '../../types/api/primaryKeys/PrimaryKey';
import { UserDetail } from '../../types/api/users/UserDetail';
import { UserRegistration } from '../../types/api/users/UserRegistration';
import { UserPermissionEntityBreakdown } from '../../types/api/users/UserPermissionEntityBreakdown';
import { TokenValidationRequest } from '../../types/api/users/TokenValidationRequest';
import { TokenValidationResponse } from '../../types/api/users/TokenValidationResponse';
import ApiRequest from '../../utils/ApiRequest';

/** Retrieves information about the current authenticated user. */
export async function getCurrentUser() {
	const result = await ApiRequest.get<UserDetail>('user');
	return result;
}

/** Returns all permission associated with a user. */
export async function getUserPermissions() {
	const result = await ApiRequest.get<readonly UserPermissionEntityBreakdown[]>('user/permissions/claims');
    return result;
}

/**
 * Returns the related person ids for the current user.
 */
export async function getRelatedPeopleForCurrentUser() {
	const result = await ApiRequest.get<readonly PersonId[]>('user/people');
	return result;
}


/**
 * Registers a new user.
 * @param newUser 
 */
export async function registerNewUser(newUser: UserRegistration) {
	await ApiRequest.post('users/register', newUser);
}

export async function validateRegistrationToken(validationParameters: TokenValidationRequest) {
	const response = await ApiRequest.post<TokenValidationResponse>('users/register/validate', validationParameters);
	return response;
}